// TODO! This file is deprecated and will be removed after refactoring the whole my-tasks page

import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import ScrollBar from 'react-perfect-scrollbar'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {DataObjectId, GTDStage, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {UserSettings} from '@client/user-settings'
import {DragData} from '@common/drag-data'
import {Tracking, TrackingEvent} from '@common/tracking'
import {SVGPreload} from '@components/common/svg-preload/svg-preload'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {
  getDefaultSortFromPage,
  SortKey,
  sortTypes,
  TaskPage
} from '@components/my-tasks/my-tasks-conf'
import {MyTasksList} from '@components/my-tasks/my-tasks-list'
import {TabId} from '@components/my-tasks/my-tasks-store'
import {processUnseen} from '@components/my-tasks/process-unseen'
import {TaskItem} from '@components/my-tasks/task-item'
import {
  keyboardHandler,
  useForceUpdate,
  useInput,
  useLocalStorage,
  useSyncEvent
} from '@containers/hooks'
import {withUpdaters} from '@containers/updaters'
import {SimpleUpdater} from '@containers/updaters/simple-updater'
import {ChatUtils} from '@extensions/chat-utils'
import {globals} from '@extensions/globals-base'
import {Task} from '@extensions/task'

const DragState: {
  up?: () => void
  draggedId?: DataObjectId
} = {}

export const TasksListsOld = observer(
  withUpdaters(SimpleUpdater(up => (DragState.up = up)))(
    ({
      currentTab,
      getCurrentTasks
    }: {
      currentTab: TabId
      getCurrentTasks: (
        currentTab: TabId,
        orderKey?: string
      ) => {
        current: TaskItem[]
        done: TaskItem[]
      }
    }) => {
      const scrollContainer = useRef<ScrollBar>(null)
      const [sort, setSort] = useLocalStorage<SortKey>(
        `my-tasks-sort-${currentTab}`,
        getDefaultSortFromPage(currentTab)
      )
      const box = Sync.getCurrentSandbox()
      const sortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        setSort(e.target.value as SortKey)
      }

      const forceUpdate = useForceUpdate()

      useSyncEvent(
        'profile',
        {filter: globals.getCompanyId(), debounceTime: 100},
        forceUpdate
      )
      useSyncEvent('current', {filter: '*', debounceTime: 200}, forceUpdate)

      const sortType = sortTypes.get(sort)

      const {current, done} = getCurrentTasks(currentTab, `${currentTab}-tasks`)
      if (sortType?.getComparator) {
        const comparator = sortType.getComparator(currentTab)
        current.sort(comparator)
      }
      const groupped = sortType?.getGrouping
        ? sortType.getGrouping(currentTab, current)
        : undefined

      const companyId = globals.getCompanyId()
      const toggleCompleted = (task: TaskItem) =>
        Task.changeCompleted(
          {...task, companyId},
          !task.completedAt,
          'my-tasks'
        )

      const setOrder = (key: string, order: DataObjectId[]) => {
        UserSettings.setOrder(key, order)
      }

      const setDragged = (e: React.DragEvent, id: DataObjectId) => {
        if (id) {
          DragData.set(e, {type: 'my-task', id})
        }
        DragState.draggedId = id
        DragState.up?.()
      }

      const itemClick = (task: TaskItem) => () => {
        if (box) {
          const hub = box.get(task.id) as Hub
          if (hub) {
            ChatUtils.openChatById(task.id)
            void Tracking.send(TrackingEvent.myTasksOpenTaskViaMyTaskSection)
          }
        }
      }

      const setStage = (task: TaskItem, stage: GTDStage, reason: string) => {
        const t = {...task, companyId}
        Task.insertInGTD(t, stage, reason)
      }

      const commonProps = {
        toggleCompleted,
        setOrder,
        draggedId: DragState.draggedId,
        setDrag: setDragged,
        itemClick
      }

      const unseen = current.filter(t => !t.stage)
      if (unseen.length > 0 && !globals.silentMode) {
        setTimeout(async () => {
          const toProcess = unseen.splice(0, 200)
          void processUnseen(toProcess)
        }, 500)
      }

      const bem = Util.bemFrom('my-tasks')

      return (
        <div className="flex flex-col h-full pb-8">
          <div className="rounded-b-4 bg-main-old h-full">
            <WithPerfectScrollbar scrollDirection="xy" ref={scrollContainer}>
              <div className={`${bem()} min-w-720`}>
                <SVGPreload
                  img={[
                    'gtd/done',
                    'gtd/undone',
                    'gtd/drag',
                    'gtd/taskinfo',
                    'gtd/gototask'
                  ]}
                />

                <div className={bem('panel')}>
                  <div className={bem('options')}>
                    <div className={bem('sort')}>
                      <div className={bem('sort-title')}>
                        {Lang.msg.taskPage.sortBy}:
                      </div>
                      <select
                        className={bem('sort-select')}
                        value={sort}
                        onChange={sortChange}
                      >
                        {[...sortTypes.values()].map(t => (
                          <option value={t.key} key={t.key}>
                            {t.getName()}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <AddTask page={currentTab} />

                  {groupped ? (
                    <div className={bem('grouping')}>
                      {groupped.map(g => (
                        <MyTasksList
                          key={g.id}
                          tasks={g.items}
                          title={g.title}
                          stage={'current'}
                          hideTitle={false}
                          page={currentTab}
                          sort={sort}
                          setStage={setStage}
                          initialExpanded={groupped.length < 2}
                          {...commonProps}
                        />
                      ))}
                    </div>
                  ) : (
                    <>
                      <MyTasksList
                        tasks={current}
                        title={Lang.msg.myTasksCurrent}
                        stage={'current'}
                        hideTitle={true}
                        page={currentTab}
                        sort={sort}
                        setStage={setStage}
                        initialExpanded={true}
                        {...commonProps}
                      />
                      {currentTab !== 'expired' && (
                        <div className={bem('grouping')}>
                          <MyTasksList
                            tasks={done}
                            title={Lang.msg.myTasksDone}
                            stage={'done'}
                            page={currentTab}
                            sort={sort}
                            setStage={setStage}
                            initialExpanded={false}
                            {...commonProps}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </WithPerfectScrollbar>
          </div>
        </div>
      )
    }
  )
)

interface Props {
  isOthers: boolean
  tasks: TaskItem[]
  toggleCompleted: (task: TaskItem) => void
  setStage: (task: TaskItem, stage: GTDStage) => void
  setOrder(key: string, order: DataObjectId[]): void
  draggedId: DataObjectId | undefined
  setDrag: (e: React.DragEvent, taskId: DataObjectId) => void
  itemClick: (task: TaskItem) => () => void
  page: TaskPage
  setPage: (page: TaskPage) => void
}
const AddTask = ({page}: Pick<Props, 'page'>) => {
  const bem = Util.bemFrom('my-tasks')
  const [addingPrivate, setAddingPrivate] = React.useState(false)
  const [text, onChange, setText] = useInput('')

  const startAddPrivate = () => setAddingPrivate(true)
  const cancelAddTask = () => {
    setText('')
    setAddingPrivate(false)
    return true
  }
  const submit = () => {
    if (text.trim() && globals.currentUserId) {
      setText('')
      if (page === 'my') {
        Task.createTask(text.trim(), {assigned: [globals.currentUserId]})
      } else if (page === 'by-me') {
        Task.createTask(text.trim(), {assignedBy: globals.currentUserId})
      } else if (page === 'starred') {
        const task = Task.createTask(text.trim(), {})
        if (task) {
          UserSettings.setStarred(task, true, 'my-tasks-favourite')
          Tracking.send(TrackingEvent.myTasksFavouriteTaskChatStarredOn)
        }
      } else {
        Task.createTask(text.trim(), {
          assigned: [globals.currentUserId],
          isPrivate: true
        })
        void Tracking.send(TrackingEvent.myTasksCreatePrivate)
      }
    } else {
      cancelAddTask()
    }
  }
  const blur = () => {
    submit()
    cancelAddTask()
  }
  const keyDown = keyboardHandler({enter: submit, escape: cancelAddTask})
  return (
    <div className={bem('add-private', {adding: addingPrivate})}>
      {addingPrivate ? (
        <input
          autoFocus={true}
          placeholder={Lang.msg.taskPlaceholder}
          className={bem('add-private-input')}
          value={text}
          onChange={onChange}
          onKeyDown={keyDown}
          onBlur={blur}
        />
      ) : (
        <div className={bem('add-private-btn')} onClick={startAddPrivate}>
          {Lang.msg.addTask}
        </div>
      )}
    </div>
  )
}
